import { BondEntity } from '../../entities/bond.entity';
import { UserTypeAction } from './actions';
import { CREATE_FORUMS, CREATE_PARTNERS, CREATE_USER } from './actionTypes';

export type UserStateType = {
  authentifie: boolean;
  id: string;
  agence?: { id: string };
  url: string;
  nom: string;
  prenom: string;
  email: string;
  token: string;
  nextAuthDate: number;
  achat: number;
  vente: number;
  profils: { nom: string; code_profil: string; url: string }[];
  manager: { nom: string; code: string; url: string; code_referent: string };
  partenaire: { nom: string; code_referent: string; url: string };
};
const INITIAL_STORE: UserStateType = {
  authentifie: false,
  id: '',
  url: '',
  agence: { id: '' },
  nom: '',
  prenom: '',
  email: '',
  token: '',
  profils: [],
  manager: { nom: '', code: '', url: '', code_referent: '' },
  partenaire: { nom: '', code_referent: '', url: '' },
  nextAuthDate: 0,
  achat: 0,
  vente: 0,
};

export interface forumType {
  model: string;
  pk: string;
  fields: forumFields;
}
interface forumFields {
  topic: string;
  description: string;
  count: string | number;
  created_at: string;
  updated_at: string;
}

export interface postType {
  model: string;
  pk: string;
  fields: PostFields;
}
interface PostFields {
  forum: string | undefined;
  user: string;
  content: string;
  title: string;
  created_at: string;
  count: string | number;
  updated_at: string;
}

export interface commentType {
  model: string;
  pk: string;
  fields: commentFields;
}
interface commentFields {
  post: string;
  user: string;
  content: string;
  created_at: string;
  author: string;
  updated_at: string;
}

export interface UserType {
  model: string;
  pk: string;
  fields: UserStateType;
}

export interface PartnerType {
  model: string;
  pk: string;
  fields: PartnerFields;
}
interface PartnerFields {
  nom: string;
  created_at: string;
  updated_at: string;
  count?: string;
  achat: number;
  vente: number;
}

export interface DetenteurType {
  id: string;
  url: string;
  qteTotal: number;
  montantGlobal: number;
  banque: string;
  agence: string;
  detenteur: string;
  bond: BondEntity;
  created_at: string;
  updated_at: string;
}

export interface AssetManagerType {
  id: string;
  nom: string;
  adresse: string;
  email: string;
  contact: string;
  created_at: string;
  updated_at: string;
  fin_abonnement: string;
  count?: string;
  achat: number;
  vente: number;
  abonnement: AbonnementType[];
}

export interface DashboardType {
  id: string;
  nom: string;
  adresse: string;
  email: string;
  contact: string;
  created_at: string;
  updated_at: string;
  fin_abonnement: string;
  count?: string;
  achat: number;
  vente: number;
  abonnement: AbonnementType[];
}

export interface PackType {
  id: string;
  nom: string;
  amount: number;
  duree_an: number;
  created_at: string;
}

export interface ParameterType {
  id: string;
  com_intermediation?: number;
  com_conservation?: number;
  droit_garde?: number;
  com_courtage?: number;
  created_at: string;
}

export interface AbonnementType {
  id: string;
  pack: PackType;
  fin_abonnement: string;
  manager: string;
  created_at: string;
}

export interface AgenceType {
  model: string;
  pk: string;
  fields: AgenceFields;
}
interface AgenceFields {
  nom: string;
  localisation?: any;
  partenaire: string;
  created_at: string;
  updated_at: string;
  count: string;
  achat: number;
  vente: number;
}

export interface TransactionType {
  model: string;
  pk: string;
  fields: TransactionFields | Partial<TransactionFields>;
}
interface TransactionFields {
  solde: number;
  etatlivraison: boolean;
  debit: string;
  credit: string;
  destinataire: string;
  intitule: string;
  numCompte: string;
  code: string;
  typeOperation: string;
  dateOperation: string;
  qte: number;
  prixNominale: string;
  montant: string;
  decote: string;
  tauxInteret: string;
  tauxRendement: string;
  frequence: string;
  couponCouruPayer: string;
  couponPercevoir: string;
  commIntermediation: string;
  commConservation: string;
  commDroitGarde: string;
  commBrokerage: string;
  operation: string;
  utilisateur: string;
  bond: string;
  created_at: string;
  updated_at: string;
  proprietaire: string;
  instrument: string;
}

export const userReducer = (state = INITIAL_STORE, action: UserTypeAction) => {
  switch (action.type) {
    case CREATE_USER:
      return {
        ...state,
        user: action.data,
      };
    case CREATE_FORUMS:
      return {
        ...state,
        forums: action.data,
      };
    case CREATE_PARTNERS:
      return {
        ...state,
        agences: action.data,
      };
    default:
      return state;
  }
};
